export default [
    {
        "name": "Red Thunder",
        "phrase": "A Storm Is Coming!",
        "stats": `
|     *    |
|   *      |
|         *|`
    },
    {
        "name": "Day Z",
        "phrase": "99 problems but speed ain't one",
        "stats": `
|         *|
|     *    |
|    *     |`
    },
    {
        "name": "Car 54",
        "phrase": "Car 54 has been located",
        "stats": `
|   *      |
|      *   |
|    *     |`
    },
    {
        "name": "Wipeout",
        "phrase": "Burning Up the Quarter Mile",
        "stats": `
|      *   |
|    *     |
|    *     |`
    },
    {
        "name": "Crazy Cabbie",
        "phrase": "fare is fair",
        "stats": `
|   *      |
|     *    |
|         *|`
    },
    {
        "name": "Captain Crush",
        "phrase": "sky pirate",
        "stats": `
|         *|
|     *    |
|*         |`
    },
    {
        "name": "kernel panic",
        "phrase": "Challenging me is a fatal error",
        "stats": `
|      *   |
|  *       |
|      *   |`
    },
    {
        "name": "Cheat-o",
        "phrase": "Orange you glad you found me?",
        "stats": `
|        * |
|       *  |
|         *|`
    },
    {
        "name": "Chrome",
        "phrase": "So shiny!",
        "stats": `
|      *   |
|    *     |
|    *     |`
    },
]